import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import TableCell from '../TableCell/TableCell';
// Component.
// -----------------------------------------------------------------------------
const TableData = forwardRef(({ children, ...rest }, ref) => {
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TableCell, { header: false, ref: ref, ...rest, children: children }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TableData.displayName = 'TableData';
export default TableData;
//# sourceMappingURL=TableData.js.map